import { Link } from "react-router-dom";
import { TrendDown, TrendUp, Wallet } from "@phosphor-icons/react";

const money = (n) =>
  `$${(Number(n) || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

// A job is losing money when costs exceed what was invoiced.
export const isUnprofitable = (j) => {
  const m = j.money;
  return !!m && m.costs_entered && m.invoiced > 0 && m.margin < 0;
};

// Costs + margin at a glance for list rows and board cards. Grey until costs exist,
// red when losing money, amber under 25 %, green otherwise.
export const MarginChip = ({ job, testId, compact = false }) => {
  const m = job.money;
  if (!m || (!m.invoiced && !m.cost_total)) return null;
  const stop = (e) => e.stopPropagation();
  if (!m.costs_entered) {
    return (
      <Link
        to={`/projects/${job.id}#costs`}
        onClick={stop}
        data-testid={testId}
        data-tone="none"
        title={`Invoiced ${money(m.invoiced)} — no costs entered yet`}
        className="font-mono-data inline-flex items-center gap-1 rounded-full border border-dashed border-zinc-700 px-2 py-0.5 text-[10px] text-zinc-500 transition-colors duration-150 hover:border-zinc-500 hover:text-zinc-300"
      >
        <Wallet size={10} weight="bold" /> {compact ? "No costs" : `${money(m.invoiced)} · no costs`}
      </Link>
    );
  }
  const bad = m.margin < 0;
  const thin = !bad && m.margin_pct != null && m.margin_pct < 25;
  const tone = bad
    ? "border-red-500/50 bg-red-500/15 text-red-300"
    : thin
      ? "border-amber-500/40 bg-amber-500/10 text-amber-300"
      : "border-emerald-500/30 bg-emerald-500/10 text-emerald-300";
  const Icon = bad ? TrendDown : TrendUp;
  return (
    <span
      data-testid={testId}
      data-tone={bad ? "loss" : thin ? "thin" : "good"}
      title={`Invoiced ${money(m.invoiced)} · costs ${money(m.cost_total)} · margin ${money(m.margin)}${
        m.margin_pct != null ? ` (${m.margin_pct}%)` : ""
      }`}
      className={`font-mono-data inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold ${tone}`}
    >
      <Icon size={10} weight="bold" />
      {compact ? "" : `${money(m.cost_total)} cost · `}
      {bad ? "−" : ""}
      {money(Math.abs(m.margin))}
      {m.margin_pct != null ? ` · ${m.margin_pct}%` : ""}
    </span>
  );
};
